import { statusTone, humanize } from '@/config/status';

export function StatusBadge({ status, dot = true, label }: { status: string; dot?: boolean; label?: string }) {
  const tone = statusTone[status] ?? 'grey';
  return <span className={`status status--${tone}`}>{dot && <span className="status__dot" />}{label ?? humanize(status)}</span>;
}
